module.exports = __webpack_public_path__ + "static/media/23a.6bef5088.jpg";